export default "__VITE_ASSET__fbff58df__"